// extracted by mini-css-extract-plugin
module.exports = {"item":"ListComponentItem_item__SiQiB"};